import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import { RouterReducerState, routerReducer } from '@ngrx/router-store';

import {
  DnvMapState, dnvMapReducer,
  DnvSearchState, dnvSearchReducer,
  LayerState, layerReducer,
  DnvLegendState, legendReducer,
  BaseMapState, baseMapReducer,
  LayerEffects, DnvLegendEffects, BaseMapEffects,
  mapViewReducer, MapViewEffects, MapViewState, ToastrEffects
} from 'dnv-lib';

import {
  applicationReducer, ApplicationState, ApplicationEffects, GetLayers
} from './application';

import { WMRPEffects, WMRPState, wmrpReducer } from './wmrp';

import { PropertiesState, propertiesReducer, PropertiesEffects } from './properties';

import { AuthState, authReducer } from './auth';


export interface State {
  mapState: DnvMapState;
  layerState: LayerState;
  legendState: DnvLegendState;
  baseMapState: BaseMapState;
  dnvSearchState: DnvSearchState;
  applicationReducer: ApplicationState;
  authReducer: AuthState;
  routerReducer: RouterReducerState;
  mapViewState: MapViewState;
  propertiesState: PropertiesState;
  wmrpState: WMRPState;
}

export const reducers: ActionReducerMap<State> = {
  mapState: dnvMapReducer,
  layerState: layerReducer,
  legendState: legendReducer,
  baseMapState: baseMapReducer,
  dnvSearchState: dnvSearchReducer,
  applicationReducer,
  authReducer,
  routerReducer,
  mapViewState: mapViewReducer,
  propertiesState: propertiesReducer,
  wmrpState: wmrpReducer
};


export const effects: any[] = [ApplicationEffects, LayerEffects, DnvLegendEffects, MapViewEffects, ToastrEffects, PropertiesEffects, BaseMapEffects, WMRPEffects];

export const getApplicationState = createFeatureSelector<ApplicationState>('applicationReducer');
export const getStatus = createSelector(
  getApplicationState,
  (state: ApplicationState) => state.status
);

export const getAppSettings = createSelector(
  getApplicationState,
  (state: ApplicationState) => state.appSettings
);

export const getGalleryOptions = createSelector(
  getApplicationState,
  (state: ApplicationState) => state.galleryOptions
);

export const getRedirectPath = createSelector(
  getApplicationState,
  (state: ApplicationState) => state.redirectPath
);

export const getGridSelectLayer = createSelector(
  getApplicationState,
  (state: ApplicationState) => state.gridSelectLayer
);

export const getGridSelectLayerCache = createSelector(
  getApplicationState,
  (state: ApplicationState) => state.gridSelectLayerCache
);

export const getToolboxMailMerge = createSelector(
  getApplicationState,
  (state: ApplicationState) => state.toolboxMailMergeState
);

export const getPopulationState = createSelector(
  getApplicationState,
  (state: ApplicationState) => state.populationState
);




// dnv-lib - DnvMapState
export const getMapState = createFeatureSelector<DnvMapState>('mapState');
export const getMarkers = createSelector(
  getMapState,
  (state: DnvMapState) => state.markers
);

export const getBaseMapState = createFeatureSelector<BaseMapState>('baseMapState');
export const getBasemaps = createSelector(
  getBaseMapState,
  (state: BaseMapState) => state.basemap
);

export const getLayerState = createFeatureSelector<LayerState>('layerState');

export const getLayerInfo = createSelector(
  getLayerState,
  (state: LayerState) => state.showLayerInfo
);

export const getPropertiesState = createFeatureSelector<PropertiesState>('propertiesState');

export const getPropertiesInfo = createSelector(
  getPropertiesState,
  (state: PropertiesState) => state.propertyInfo
);

export const getSelectedProperty = createSelector(
  getPropertiesState,
  (state: PropertiesState) => state.selectedProperty
);

export const getPropertiesDBLink = createSelector(
  getPropertiesState,
  (state: PropertiesState) => state.propertiesDBLink
);

export const getEnerGovInfo = createSelector(
  getPropertiesState,
  (state: PropertiesState) => state.energovInfo
);

export const getWMRPState = createFeatureSelector<WMRPState>('wmrpState');

export const getWMRPModule = createSelector(
  getWMRPState,
  (state: WMRPState) => state.module
);

export const getWMRPAnalysisData = createSelector(
  getWMRPState,
  (state: WMRPState) => state.recentAnalysisRunData
)

export const getMaterials = createSelector(
  getWMRPState,
  (state: WMRPState) => state.materials
);

export const getSavedTemplate = createSelector(
  getWMRPState,
  (state: WMRPState) => state.savedTemplate
);

export const getCurrentConditions = createSelector(
  getWMRPState,
  (state: WMRPState) => state.currentConditions
);

export const getReplacementSchedules = createSelector(
  getWMRPState,
  (state: WMRPState) => state.replacementSchedules
);

export * from './application';
export * from './properties';
export * from './wmrp';
